export const week_options = [4, 12, 24, 28, 52];

export const platform_access_package_uuid = '9ed2ff97-de27-408f-8366-0f4a54b757ef';

export const filter_create_membership_packages = (active_packages) =>
  active_packages.filter((active_package) => active_package.uuid !== platform_access_package_uuid);

export const get_selected_package = (active_packages, package_uuid) =>
  active_packages.find((active_package) => active_package.uuid === package_uuid) || {};

export const build_active_packages_url = (active_packages_url, student_uuid) =>
  `${active_packages_url}?student_uuid=${encodeURIComponent(student_uuid)}`;

export const get_package_charge_amount = (selected_package, number_of_week) => {
  const price_by_week = {
    4: selected_package.price,
    12: selected_package.price_12_weeks,
    24: selected_package.price_24_weeks,
    28: selected_package.price_28_weeks,
    52: selected_package.price_52_weeks
  };

  return price_by_week[Number(number_of_week)];
};

export const format_package_charge_amount = (selected_package, number_of_week) => {
  const charge_amount = get_package_charge_amount(selected_package, number_of_week);
  if (charge_amount === undefined || charge_amount === null || charge_amount === '') {
    return 'Not available';
  }

  const currency_symbol = selected_package.currency_symbol || '$';
  const currency = selected_package.currency || 'USD';
  return `${currency_symbol}${Number(charge_amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${currency}`;
};

export const build_create_membership_payload = ({
  package_uuid,
  student_uuid,
  subscription_start_date,
  number_of_week,
  change_to_four_weeks_on_renewal,
  country
}) => ({
  package_uuid,
  student_uuid,
  subscription_start_date,
  discount_3m_plan_1m_free: 0,
  number_of_week: Number(number_of_week),
  source: 'WEB',
  platform: '',
  country: country || 'US',
  plan_purchase_on_cancellation: 0,
  change_to_four_weeks_on_renewal: change_to_four_weeks_on_renewal ? 1 : 0,
  is_free_month_offer: 0
});
